import { tKey, type I18nKey } from "@/core/i18n";
import { OrgMemberRoleEnum } from "@repo/schema";

/** Role names in the role selects and invitations ("Admin"). */
export const orgRoleLabel = {
  [OrgMemberRoleEnum.OWNER]: tKey("account:roles.OWNER"),
  [OrgMemberRoleEnum.ADMIN]: tKey("account:roles.ADMIN"),
  [OrgMemberRoleEnum.MEMBER]: tKey("account:roles.MEMBER"),
} satisfies Record<OrgMemberRoleEnum, I18nKey<"account">>;

/** The member-list badge, which shows the role in capitals ("OWNER"). */
export const orgRoleBadge = {
  [OrgMemberRoleEnum.OWNER]: tKey("account:roleBadges.OWNER"),
  [OrgMemberRoleEnum.ADMIN]: tKey("account:roleBadges.ADMIN"),
  [OrgMemberRoleEnum.MEMBER]: tKey("account:roleBadges.MEMBER"),
} satisfies Record<OrgMemberRoleEnum, I18nKey<"account">>;
